

























import { defineComponent, ref } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'ExpanderBox',
  components: {
    UCIcon,
  },
  props: {
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    inlineActions: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const expanded = ref(props.alwaysOpen);

    const onToggle = () => {
      expanded.value = !expanded.value;
    };

    return {
      expanded,
      onToggle,
    };
  },
});
